import { ContextMenu, showActionsPage } from 'Components'
import { useState, useEffect }  from 'react'
import { connect } from 'react-redux'
import { createRelationInGraph, expandNodes, constructEmbeddedGraphUrl } from 'Services/GraphUtils'
import { getNamespaceLabel } from 'Services/WeaverUtils'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { useQuery } from 'Hooks'
import SizeService from 'Services/SizeService'
import ColorService from 'Services/ColorService'
import { Macro } from 'Model'
import * as Types from 'Types'

import {
  setCreatingNode
  setCurrentItem
  setEditingNode
  setDefaultQuery
  setTab
  setTabDisabled
  setTableConfig
} from 'Actions/explore'

import {
  removeGraphEdge
  removeGraphEdges
  removeGraphNode
  removeGraphNodes
  setGraphAddingEdge
  setGraphCreatingEdge
  setGraphRenameRelationProps
  setGraphShowingNode
  updateGraphNodes
  setGraphColorPickerProps
} from 'Actions/graph'

import {
  setFilteredNodesByOther
  updateTypeFilter
  updateTypeFilters
} from 'Actions/graphFilter'

import {
  defaultNodesTableConfig,
  defaultTypesTableConfig,
  getMemberKey,
  getMemberKeys,
  getTypeForNode,
  getNodeLabel
  getTypeNodeForNode,
  getProjectData,
  splitUid
  getUid
  WeaverQuery
} from 'Services/WeaverUtils'
import { message, Modal } from 'antd'
import {
  NODE
  RELATION
  VIEWTYPE
  ATTRIBUTES
  QUERY
} from 'Types'

import {
  AnalyserNode
  AudioCtx
  CompressorNode
  DelayNode
  OscNode
  SequencerNode
  Sequencer
  GainNode
  StereoPanNode
  FilterNode
  PannerNode
} from 'Synth'

GraphContextMenu = ({ currentItem, isEmbeddedView, data, children, macros, nodeView, props... }) ->

  { graphData, active } = data

  [activeNode, setActiveNode] = useState(undefined)
  [activeSelection, setActiveSelection] = useState(undefined)
  [isPublic, setIsPublic] = useState(false)
  params = useQuery()
  history = useHistory()
  { url } = useRouteMatch()
  { hash }  = useLocation()

  getNodeAndType = (id) ->
    graphData.nodes[id]

  getRelation = (id) ->
    if edge = graphData.nodes[id]
      edge
    else
      graphData.edges[id]

  useEffect(->
    (->
      if active?.type is NODE
        if _.size(active.nodes) is 1
          setActiveNode(getNodeAndType(active.nodes[0]))
          setActiveSelection(undefined)
        else
          nodes = _.map(active.nodes, (id) ->
            getNodeAndType(id)
          )
          setActiveSelection(_.map(active.nodes, getNodeAndType))
          setActiveNode(undefined)
      else if active?.type is RELATION
        if _.size(active.edges) is 1
          setActiveNode(getRelation(active.edges[0]))
          setActiveSelection(undefined)
        else if _.size(active.nodes) is 1
          setActiveNode(getRelation(active.nodes[0]))
          setActiveSelection(undefined)
        else
          setActiveSelection(_.map(active.edges, getRelation))
          setActiveNode(undefined)
      else
        setActiveSelection(undefined)
        setActiveNode(undefined)
    )()
    undefined
  , [active])

  useEffect(->
    (->
      currProj = await Weaver.Project.load(props.currentProject)
      acl = await currProj.getACL()
      spaceIsPublic = await acl.getPublicReadAccess()
      setIsPublic(spaceIsPublic)
    )()
    undefined
  , [])

  macroEditMenuItem = {
    key: 'edit-sequence'
    title: 'Edit via form'
    requiresWriteAccess: true
    hidden: -> not (activeNode?.id? and macros.length > 0 and not activeNode?.from?)
  }

  macroList = macros.map((m) -> m.get('configBlob'))

  createMacroSubMenu = (macroList) ->
    items = _.map(macroList, (macro) ->
      {
        key: _.kebabCase(macro.title)
        title: macro.title
        onClick: ->
          nodeId = activeNode.id
          showActionsPage({ macro..., nodeId, mode: 'edit', title: 'Edit' })
      }
    )
    if items.length is 1
      macroEditMenuItem.onClick = items[0].onClick
    else
      macroEditMenuItem.submenu = items

  typeIds = []
  if activeNode?.type?
    typeIds = activeNode.type.map((t) -> t.id)
  typedMacros = macroList.filter((m) -> _.get(m, 'formSequence.onSave.node.typeNode') in typeIds)
  untypedMacros = macroList.filter((m) -> !_.get(m, 'formSequence.onSave.node.typeNode')?)
  createMacroSubMenu([untypedMacros..., typedMacros...])

  actions = [(getProjectData().getProjectSpecificActions?({ activeNode, currentItem, data, props... }) or [])..., {
    key: 'open'
    title: 'Open'
    submenu: [{
      key: 'open-in-graph'
      title: ->
        if activeNode?
          <span>Open <b>{activeNode?.label}</b> in graph view</span>
        else
          <span>Open <b>{_.size(activeSelection)} nodes</b> in graph view</span>
      onClick: ->
        if activeNode?.sources?
          props.setCurrentItem({
            type: QUERY
            data: {
              query: new Weaver.Query()
                .restrict(activeNode.sources)
                .selectOut('*')
                .selectIn('*')
            }
          })
        else if activeNode?
          props.setCurrentItem({
            id: activeNode.id
            type: NODE
          })
        else
          props.setCurrentItem({
            type: QUERY
            data: {
              query: new Weaver.Query()
                .restrict(_.map(activeSelection, 'id'))
                .selectOut('*')
                .selectIn('*')
            }
          })
      hidden: active?.type isnt NODE
    }, {
      key: 'current-graph-in-table'
      title: 'Open current graph in table'
      onClick: ->
        ids = _.reduce(graphData.nodes, (acc, { graph, type }, id) ->
          acc = [
            acc...
            id
          ]
        , []).filter((id) ->
          id not in props.filteredNodes
        )
        { title, columns } = defaultNodesTableConfig(ids)
        data = { title, ids, columns }

        props.setTableConfig({
          type: NODE,
          data
        })
      hidden: ->
        not graphData or _.size(graphData.nodes) is 0 or active? or graphData.abstract is true
    }, {
      key: 'open-in-table'
      title: ->
        if activeNode?
          <span>Open <b>{activeNode?.label}</b> in table</span>
        else
          <span>Open <b>{_.size(activeSelection)} nodes</b> in table</span>
      onClick: ->
        items = if activeNode? then [activeNode.id] else _.map(activeSelection, 'id')
        { title, ids, columns } = defaultNodesTableConfig(items)

        data = {
          title,
          ids,
          columns
        }

        props.setTableConfig({
          type: NODE,
          data
        })
      hidden: active?.type isnt NODE or graphData.abstract is true
    }, {
      key: 'type-view-of-this-node'
      title: ->
        <span>Open type view for type <b>{getNamespaceLabel(activeNode?.type?[0]?.label)}</b></span>
      onClick: ->
        props.setCurrentItem({
          id: activeNode.type[0].id
          type: NODE
          viewType: VIEWTYPE.ABSTRACT
        })
      hidden: ->
        active?.type isnt NODE or not activeNode?.type?[0]? or activeSelection?
    }, {
      key: 'open-all-of-this-type'
      title: ->
        <span>Open all nodes for type <b>{activeNode?.type?.label if activeNode?}</b> in table</span>
      onClick: ->
        { type } = activeNode
        data = await defaultTypesTableConfig(type)
        props.setTableConfig({
          type: 'TYPES',
          data
        })
      hidden: ->
        active?.type isnt NODE or not activeNode?.type? or activeSelection?
    }]
  }, {
    key: 'hide'
    title: 'Hide'
    submenu: [{
      key: 'hide-node'
      title: ->
        if activeNode?
          <span>Hide <b>{activeNode?.label}</b> from graph</span>
        else
          <span>Hide <b>{_.size(activeSelection)} nodes</b> from graph</span>
      onClick: ->
        if activeNode?
          props.removeGraphNode(activeNode.id)
        else
          props.removeGraphNodes(_.map(activeSelection, 'id'))
      hidden: active?.type isnt NODE
    }, {
      key: 'all-of-this-type'
      title:
        <span>Hide all nodes for type <b>{activeNode?.type?.label if activeNode?}</b></span>
      onClick: ->
        props.updateTypeFilter({
          id: activeNode.type.id
          label: activeNode?.type?.label
          enabled: false
        })
      hidden: ->
        active?.type isnt NODE or not activeNode?.type? or activeSelection?
    }, {
      key: 'all-unrelated'
      title: ->
        <span>Hide all unrelated nodes to <b>{activeNode?.label}</b></span>
      onClick: ->
        { nodes, edges } = graphData
        nodesToShow = _.filter(edges, (edge) ->
          edge.from is activeNode.id or edge.to is activeNode.id
        ).reduce((acc, edge) ->
          source = edge.from
          target = edge.to

          if source not in acc
            acc.push(source)
          if target not in acc
            acc.push(target)

          acc
        , [])

        nodesToShow.push(activeNode.id)

        nodesToHide = Object.keys(nodes).filter((node) ->
          node not in nodesToShow
        )

        props.setFilteredNodesByOther(nodesToHide)
      hidden: active?.type isnt NODE or activeSelection?
    }, {
      key: 'hide-other-types'
      title: ->
        <span>Hide all types except <b>{activeNode?.type?.label}</b></span>
      onClick: ->
        [id, graph] = splitUid(activeNode.type.id)
        typesToHide = await new WeaverQuery()
          .hasNoRecursiveRelationOut(getMemberKey(), Weaver.Node.getFromGraph(id, graph), true)
          .hasRelationIn(getMemberKeys())
          .find()

        props.updateTypeFilters(
          _.keyBy(_.map(typesToHide, (type) ->
            {
              id: getUid(type)
              label: getNodeLabel(type)
              enabled: false
            }
          ), 'id')
        )
      hidden: ->
        active?.type isnt NODE or not activeNode?.type?
    }]
  }, {
    key: 'create-node'
    title: 'Create node'
    requiresWriteAccess: true
    onClick: ->
      props.setCreatingNode(true)
    hidden: active? or graphData.abstract
  }, {
    key: 'edit-node'
    title: ->
      <span>Edit <b>{activeNode?.label}</b></span>
    requiresWriteAccess: true
    onClick: ->
      [id, graph] = splitUid(activeNode.id)
      props.setEditingNode(await new Weaver.Query().restrict(Weaver.Node.getFromGraph(id, graph)).withRelations().first())
    hidden: active?.type isnt NODE or graphData.abstract or activeSelection?
  }, {
    macroEditMenuItem...
  }, {
    key: 'edit-color'
    title: 'Edit color'
    requiresWriteAccess: true
    submenu: [{
      key: 'edit-color-for-type'
      title: ->
        <span>Edit color for type <b>{activeNode?.type?.label}</b></span>
      onClick: ->
        props.setGraphColorPickerProps({
          target: activeNode.type.id
          event: active.event
          getColor: (target) ->
            ColorService.getColorForType(target)
          onSave: (uid, color) ->
            ColorService.setColorForType(uid, color)
            props.updateGraphNodes({
              groups: {
                [uid]: {
                  graphData.groups[uid]...
                  color
                }
              }
            })
        })
      hidden: ->
        not activeNode?.type?
    }, {
      key: 'edit-color-for-graph'
      title: ->
        <span>Edit color for graph <b>{activeNode?.graph}</b></span>
      onClick: ->
        props.setGraphColorPickerProps({
          target: activeNode.graph
          event: active.event
          getColor: (target) ->
            ColorService.getColorForGraph(target)
          onSave: (graph, color) ->
            ColorService.setColorForGraph(graph, color)
            props.updateGraphNodes({
              groups: {
                [graph]: {
                  graphData.groups[graph]...
                  color
                }
              }
            })
        })
      hidden: ->
        not activeNode?.graph?
    }]
    hidden: ->
      not activeNode?.type? and not activeNode?.graph?
  }, {
    key: 'set-size'
    title: ->
      <span>Set size for type <b>{activeNode?.type?.label}</b></span>
    submenu: [
      ['xs', 'Extra small']
      ['sm', 'Small']
      ['md', 'Medium']
      ['lg', 'Large']
      ['xl', 'Extra large']
    ].map(([size, label]) ->
      {
        key: "set-size-#{ size }"
        title: label
        onClick: ->
          id = activeNode.type.id
          size = SizeService.setSizeForType(id, size)
          if not graphData.abstract
            props.updateGraphNodes({
              groups: {
                [id]: {
                  graphData.groups[id]...
                  size
                }
              }
            })
      }
    )
    hidden: ->
      if currentItem?.viewType is VIEWTYPE.ABSTRACT then true else not activeNode?.type?
  }, {
    key: 'create-relation'
    requiresWriteAccess: true
    title: 'Create relation'
    onClick: ->
      props.setGraphCreatingEdge(undefined)
      props.setGraphAddingEdge(true)
    hidden: active? or _.isEmpty(graphData.nodes)
  }, {
    key: 'create-relation-from'
    requiresWriteAccess: true
    title: ->
      if activeNode?
        <span>Create relation from <b>{activeNode?.label}</b></span>
      else if activeSelection?
        <span>Create relation from <b>{_.size(activeSelection)} nodes</b></span>
    onClick: ->
      sources = if activeNode? then [activeNode] else activeSelection
      sourceIds = _.map(sources, 'id')

      props.setGraphAddingEdge(false)
      promise = new Promise((resolve, reject) =>
        props.setGraphCreatingEdge({
          x: active.event.layerX
          y: active.event.layerY
          edgeData: {
            from: if sourceIds.length is 1 then sourceIds[0] else sourceIds
          }
          promise: {
            resolve
            reject
          }
        })
      )

      { sources, relKeys, targets } = await promise
      props.updateGraphNodes(await createRelationInGraph(relKeys, sources, targets))
      props.setGraphCreatingEdge(undefined)
    hidden: active?.type isnt NODE or graphData.abstract
  }, {
    key: 'create-relation-to'
    requiresWriteAccess: true
    title: ->
      if activeNode?
        <span>Create relation to <b>{activeNode?.label}</b></span>
      else if activeSelection?
        <span>Create relation to <b>{_.size(activeSelection)} nodes</b></span>
    onClick: ->
      targets = if activeNode? then [activeNode] else activeSelection
      targetIds = _.map(targets, 'id')

      props.setGraphAddingEdge(false)
      promise = new Promise((resolve, reject) =>
        props.setGraphCreatingEdge({
          edgeData: {
            to: if targetIds.length is 1 then targetIds[0] else targetIds
          }
          x: active.event.layerX
          y: active.event.layerY
          promise: {
            resolve
            reject
          }
        })
      )

      { sources, relKeys, targets } = await promise
      props.updateGraphNodes(await createRelationInGraph(relKeys, sources, targets))
      props.setGraphCreatingEdge(undefined)
    hidden: active?.type isnt NODE or graphData.abstract
  }, {
    key: 'copy-url'
    title: ->
      <span>Copy shareable link for <b>{activeNode?.label}</b></span>
    onClick: ->
      await navigator.clipboard.writeText("#{location.origin}/#{props.currentProject}##{activeNode.id}")
      message.success('Copied to clipboard')
    hidden: ->
      active?.type isnt NODE or activeSelection
  },{
    key: 'add-remove-relation-attributes'
    title: ->
      <span>Add/Remove attributes on <b>{ activeNode?.key }</b></span>
    requiresWriteAccess: true
    onClick: ->
      [id, graph] = splitUid(activeNode.id)
      props.setEditingNode(await new Weaver.Query().restrict(Weaver.Node.getFromGraph(id, graph)).withRelations().first())
    hidden: ->
      active?.type isnt RELATION or activeNode?.id.includes('->') or graphData.abstract or activeSelection?
  }, {
    key: 'rename-relation'
    title: ->
      <span>Rename relation <b>{ activeNode?.key }</b></span>
    requiresWriteAccess: true
    onClick: ->
      [id, graph] = splitUid(activeNode.id)
      promise = new Promise((resolve, reject) ->
        props.setGraphRenameRelationProps({
          id
          graph
          key: activeNode.key
          promise: {
            resolve,
            reject
          }
        })
      )

      { key } = await promise

      props.updateGraphNodes(await createRelationInGraph(key, activeNode.from, activeNode.to))
      props.removeGraphEdge(activeNode.id)

      await Weaver.Node.getFromGraph(id, graph).destroy()
      setActiveNode(undefined)
      props.setGraphRenameRelationProps(undefined)
    hidden: ->
      active?.type isnt RELATION or activeNode?.id.includes('->')  or activeSelection or graphData.abstract
  }, {
    key: 'reverse-relation'
    title: ->
      <span>Reverse relation <b>{ activeNode?.key }</b></span>
    requiresWriteAccess: true
    onClick: ->
      [id, graph] = splitUid(activeNode.id)
      props.removeGraphEdge(activeNode.id)
      props.updateGraphNodes(await createRelationInGraph("#{activeNode.key}", activeNode.to, activeNode.from))
      await Weaver.Node.getFromGraph(id, graph).destroy()
      setActiveNode(undefined)
    hidden: ->
      active?.type isnt RELATION or activeNode?.id.includes('->') or activeSelection or graphData.abstract
  }, {
    key: 'expand-all-of-type'
    title: ->
      <span>Expand all nodes of type <b>{ activeNode?.type?.label }</b></span>
    onClick: ->
      { nodes } = graphData
      typeId = activeNode.type.id

      nodesToExpand = _.filter(nodes, ({ id, group }) ->
        group is typeId and id isnt typeId
      )

      props.updateGraphNodes(await expandNodes(_.map(nodesToExpand, 'id')))

    hidden: active?.type isnt NODE or not activeNode?.type?
  }, {
    key: 'invert-selection'
    title: 'Invert selection'
    onClick: ->
      nodes = _.without(nodeView.getIds(), active.network.getSelectedNodes()...)
      active.network.setSelection({ nodes }, { highlightEdges: false })
    hidden: active?.type isnt NODE or (not activeNode? and not activeSelection?)
  }, {
    key: 'destroy-node'
    title: ->
      if activeNode?
        <span>Destroy <b>{activeNode?.label}</b></span>
      else
        <span>Destroy <b>{_.size(activeSelection)} nodes</b></span>
    danger: true
    requiresWriteAccess: true
    requiresConfirmation: true
    confirmationTitle: ->
      if activeNode?
        <span>Are you sure you want to destroy <b>{activeNode?.label}</b></span>
      else
        <span>Are you sure you want to destroy <b>{_.size(activeSelection)} nodes</b></span>
    onClick: ->
      { nodes } = graphData

      nodesToDestroy = if activeNode? then [activeNode] else activeSelection
      destroyedIds = _.map(nodesToDestroy, 'id')

      await Weaver.Node.batchDestroy(_.map(destroyedIds, (id) ->
        [id, graph] = splitUid(id)
        Weaver.Node.getFromGraph(id, graph)
      ))

      nodesToUpdate = _.filter(nodes, (node) ->
        node.group in destroyedIds
      ).reduce((acc, node) ->
        acc[node.id] = {
          node...
          group: 'undefined'
        }
        acc
      , {})

      if (
        currentItem.type is ATTRIBUTES and
        currentItem.id in destroyedIds
      )
        props.setTabDisabled({ key: 'attributes', disabled: true })
        params.set('tab', 'home')
        history.replace({ pathname: url, search: params.toString(), hash })
        setTab('home')

      setActiveNode(undefined)
      props.updateGraphNodes({ nodes: nodesToUpdate })
      props.removeGraphNodes(destroyedIds)
    hidden: active?.type isnt NODE or graphData.abstract
  }, {
    key: 'destroy-relation'
    danger: true
    requiresConfirmation: true
    confirmationTitle: ->
      if activeNode?
        <span>Are you sure you want to destroy relation <b>{ activeNode?.key }</b></span>
      else
        <span>Are you sure you want to destroy <b>{_.size(activeSelection)} relations</b></span>

    requiresWriteAccess: true
    title: ->
      if activeNode?
        <span>Destroy relation <b>{ activeNode?.key }</b></span>
      else
        <span>Destroy <b>{_.size(activeSelection)} relations</b></span>
    onClick: ->
      { nodes, edges } = graphData

      relsToDestroy = if activeNode? then [activeNode] else activeSelection
      destroyedIds = _.map(relsToDestroy, 'id')

      edges = _.map(destroyedIds, (id) ->
        edges[id]
      )

      nodesToUpdate = {}

      await Weaver.Node.batchDestroy(_.map(destroyedIds, (id) ->
        [id, graph] = splitUid(id)
        Weaver.RelationNode.getFromGraph(id, graph)
      ))

      await Promise.map(edges, (edge) ->
        if edge.key in getMemberKeys()
          members = await new Weaver.Query()
            .hasRelationOut(edge.key, Weaver.Node.get(edge.to))
            .find()

          if not members.length > 0
            nodesToUpdate[edge.to] = {
              nodes[edge.to]...
              group: 'undefined'
            }

          newTypes = _.flatten(await Promise.map(getMemberKeys(), (memberKey) ->
            new Weaver.Query()
              .hasRelationIn(memberKey, Weaver.Node.get(edge.from))
              .find()
          ))

          nodesToUpdate[edge.from] = {
            nodes[edge.from]...
            group: if newTypes.length > 0 then newTypes[0].id() else 'undefined'
          }
      )

      setActiveNode(undefined)
      props.removeGraphEdges(destroyedIds)
      props.updateGraphNodes({ nodes: nodesToUpdate })
    hidden: active?.type isnt RELATION or activeNode?.id.includes('->')  or graphData.abstract
  }, {
    key: 'show'
    title: 'Show'
    submenu: [{
      key: 'other-node-in-graph'
      title: ->
        <span>Show a node in this graph</span>
      onClick: ({ domEvent: { clientX, clientY }}) ->
        props.setGraphShowingNode({
          event: { clientX, clientY }
        })
    }]
    hidden: _.keys(graphData.nodes).length < 1 or active?
  }, {
    key: 'save-graph-as-view'
    title: 'Save as view'
    onClick: ->
      param = "restrict ".concat(
        nodeView
          .map(({ id }) -> id)
          .filter((id) -> id.indexOf('@') is -1)
          .map((id) -> "'#{ id }'").join(' ')
      ) + "\nselectOut '*'"
      history.push("#{props.currentProject}/settings/views/new?viewType=graphView&query=#{ param }")
    hidden: _.keys(graphData.nodes).length < 1 or active?
    requiresWriteAccess: true
  }, {
    key: 'embed-graph-view'
    title: 'Embed view'
    onClick: ->
      url = window.location.href.split(props.currentProject)[0]
      url = "#{url}#{props.currentProject}/embedded?"
      if currentItem.type is 'QUERY'
        url = constructEmbeddedGraphUrl(url, currentItem.data.query)
      else
        restrict = nodeView
          .map(({ id }) -> id)
          .filter((id) -> id.indexOf('@') is -1)
          .map((id) -> "#{ id }")

        selectOut = ["*"]
        url = "#{url}restrict=#{JSON.stringify(restrict)}&selectOut=[\"*\"]"

      Modal.info({
        icon: null
        bodyStyle: {
          display: 'flex'
          flexDirection: 'column'
          alignItems: 'flex-start'
          overflow: 'auto'
        }
        width: '60%'
        title: <span>{url}</span>
        closable: true
        okText: "Copy to clipboard"
        onOk: () ->
          await navigator.clipboard.writeText("#{url}")
          message.success('Copied to clipboard')
      })
    hidden: -> not isPublic or _.isEmpty(data.graphData.nodes)
    requiresWriteAccess: true
  }, {
    key: 'save-graph-as-image'
    title: 'Save as image'
    onClick: ->
      canvas = document.getElementById("graph-container").children[0].children[0]
      tmpLink = document.createElement('a')
      tmpLink.download = 'graph.png'
      tmpLink.href = canvas.toDataURL('image/png')
      document.body.appendChild(tmpLink)
      tmpLink.click()
      document.body.removeChild(tmpLink)
    hidden: _.isEmpty(graphData.nodes) or active?
  }, {
    key: 'synthesizer'
    title: 'Synthesizer Menu'
    requiresWriteAccess: true
    hidden: not props.synthesizerEnabled
    submenu: [{
        key: 'create-audio-context'
        title: 'Create Audio Context'
        onClick: ->
          n = new AudioCtx()
          id = getUid(n.id())
          await n.create()
          props.updateGraphNodes({
            nodes: {
              [id]: {
                id: id
                label: getNodeLabel(n)
                type: 'NODE'
                graph: n.graph
                group: getTypeForNode(n)
              }
            }
          })
      }, {
          key: 'create-oscillator'
          title: 'Create Oscillator'
          onClick: ->
            n = new OscNode()
            id = getUid(n.id())
            await n.create()
            props.updateGraphNodes({
              nodes: {
                [id]: {
                  id: id
                  label: getNodeLabel(n)
                  type: 'NODE'
                  graph: n.graph
                  group: getTypeForNode(n)
                }
              }
            })
      }, {
          key: 'create-sequencer'
          title: 'Create Sequencer'
          onClick: ->
            n = new SequencerNode()
            id = getUid(n.id())
            await n.create()
            props.updateGraphNodes({
              nodes: {
                [id]: {
                  id: id
                  label: getNodeLabel(n)
                  type: 'NODE'
                  graph: n.graph
                  group: getTypeForNode(n)
                }
              }
            })
      }, {
          key: 'create-gain'
          title: 'Create Gain'
          onClick: ->
            n = new GainNode()
            id = getUid(n.id())
            await n.create()
            props.updateGraphNodes({
              nodes: {
                [id]: {
                  id: id
                  label: getNodeLabel(n)
                  type: 'NODE'
                  graph: n.graph
                  group: getTypeForNode(n)
                }
              }
            })
      }, {
          key: 'create-stereo-pan'
          title: 'Create Stereo Pan'
          onClick: ->
            n = new StereoPanNode()
            id = getUid(n.id())
            await n.create()
            props.updateGraphNodes({
              nodes: {
                [id]: {
                  id: id
                  label: getNodeLabel(n)
                  type: 'NODE'
                  graph: n.graph
                  group: getTypeForNode(n)
                }
              }
            })
      }, {
          key: 'create-filter'
          title: 'Create Filter'
          onClick: ->
            n = new FilterNode()
            id = getUid(n.id())
            await n.create()
            props.updateGraphNodes({
              nodes: {
                [id]: {
                  id: id
                  label: getNodeLabel(n)
                  type: 'NODE'
                  graph: n.graph
                  group: getTypeForNode(n)
                }
              }
            })
      },{
        key: 'create-compressor'
        title: 'Create Compressor'
        onClick: ->
          n = new CompressorNode()
          id = getUid(n.id())
          await n.create()
          props.updateGraphNodes({
            nodes: {
              [id]: {
                id: id
                label: getNodeLabel(n)
                type: 'NODE'
                graph: n.graph
                group: getTypeForNode(n)
              }
            }
          })
      }, {
        key: 'create-analyser'
        title: 'Create Analyser'
        onClick: ->
          n = new AnalyserNode()
          id = getUid(n.id())
          await n.create()
          props.updateGraphNodes({
            nodes: {
              [id]: {
                id: id
                label: getNodeLabel(n)
                type: 'NODE'
                graph: n.graph
                group: getTypeForNode(n)
              }
            }
          })
      }, {
        key: 'create-delay'
        title: 'Create Delay'
        onClick: ->
          n = new DelayNode()
          id = getUid(n.id())
          await n.create()
          props.updateGraphNodes({
            nodes: {
              [id]: {
                id: id
                label: getNodeLabel(n)
                type: 'NODE'
                graph: n.graph
                group: getTypeForNode(n)
              }
            }
          })
        }, {
            key: 'create-panner'
            title: 'Create Panner'
            onClick: ->
              n = new PannerNode()
              id = getUid(n.id())
              await n.create()
              props.updateGraphNodes({
                nodes: {
                  [id]: {
                    id: id
                    label: getNodeLabel(n)
                    type: 'NODE'
                    graph: n.graph
                    group: getTypeForNode(n)
                  }
                }
              })
        }]

  }]
  if isEmbeddedView
    actions = _.filter(actions, ['key', 'save-graph-as-image'])
  <ContextMenu actions={actions}>
    { children }
  </ContextMenu>


export default connect(({ graph, graphFilter, projects, explore }) ->
  currentItem: explore.currentItem
  isEmbeddedView: graph.isEmbeddedView
  currentProject: projects.currentProject
  macros: explore.macros
  nodeView: graph.nodeView
  synthesizerEnabled: graph.synthesizerEnabled
  filteredNodes: [
    graphFilter.filteredNodes.byGraph...
    graphFilter.filteredNodes.byOther...
    graphFilter.filteredNodes.byRelation...
    graphFilter.filteredNodes.byOther...
    graphFilter.filteredNodes.byType...
  ]
, {
  removeGraphEdge
  removeGraphEdges
  removeGraphNode
  removeGraphNodes
  setCreatingNode
  setGraphColorPickerProps
  setEditingNode
  setCurrentItem
  setFilteredNodesByOther
  setTabDisabled
  setTab
  setGraphAddingEdge
  setGraphCreatingEdge
  setGraphRenameRelationProps
  setGraphShowingNode
  setTableConfig
  updateGraphNodes
  updateTypeFilter
  updateTypeFilters
})(GraphContextMenu)
